/**
 * src/utils/format.js
 *
 * Helper genérico de formato numérico con separador de miles
 * (estilo "1.234.567"). Reemplaza el bridge window.formatNumber que
 * vivía en src/main.js post-3.15 (DT-10).
 *
 * Implementación migrada byte-a-byte de main.js:55-58.
 *
 * Migrado en sub-fase 3.16 — cierre formal de FASE 3.
 */

export const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return num;
    return Math.floor(Number(num)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
